import { Module } from '../Module';
import { SiteRoles } from '../ServerApi/types/ISiteRole';
import { ServerService } from '../services/ServerService';

export interface Permission {
  key: string;
  translate: string;
}

export interface ISiteRolePermissionsTableScope extends ng.IScope {
  siteRoles: string[];
  rows: ISiteRolePermissions[];
  permissions: Permission[];
}

Module.instance().directive('tbSiteRolePermissionsTable', <any[]>['$translate', 'ServerService',
  ($translate: ng.translate.ITranslateService, server: ServerService) => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'siteRolePermissionsTable.html',
      link: (scope: ISiteRolePermissionsTableScope) => {
        scope.rows = SiteRolePermissions.permissionsForRoles(server);
        scope.permissions = SiteRolePermissions.permissions(server, $translate);
      }
    };
  }
]);

export interface ISiteRolePermissions {
  role: string;
  viewInteract?: boolean;
  subscriptionsAndAlerts?: boolean;
  webEdit?: boolean;
  publishViews?: boolean;
  createDataSource?: boolean;

  divider?: boolean;
}

export class SiteRolePermissions {

  public static viewInteract: string = 'viewInteract';
  public static subscriptionsAndAlerts: string = 'subscriptionsAndAlerts';
  public static webEdit: string = 'webEdit';
  public static publishViews: string = 'publishViews';
  public static createDataSource: string = 'createDataSource';

  private static availablePermissions: string[] = [SiteRolePermissions.viewInteract, SiteRolePermissions.subscriptionsAndAlerts, SiteRolePermissions.webEdit, SiteRolePermissions.publishViews];

  private static getPermission(permission: string, $translate: ng.translate.ITranslateService) : Permission {
    return { key: permission, translate: $translate.instant(permission) };
  }

  public static permissions(serverService: ServerService, $translate: ng.translate.ITranslateService): Permission[] {
    const permissions: Permission[] = [];
    SiteRolePermissions.availablePermissions.forEach(element => {
      permissions.push(SiteRolePermissions.getPermission(element, $translate));
    });
    if (serverService.hasCreatorTier()) {
      permissions.push(SiteRolePermissions.getPermission(SiteRolePermissions.createDataSource, $translate));
    }
    return permissions;
  }

  public static permissionsForRoles(serverService: ServerService): ISiteRolePermissions[] {
    const siteRolePermissions: ISiteRolePermissions[] = [];

    // Creator
    if (serverService.hasCreatorTier()) {
      siteRolePermissions.push(
          {
            role: SiteRoles.Creator,
            viewInteract: true,
            subscriptionsAndAlerts: true,
            webEdit: true,
            publishViews: true,
            createDataSource: true
          }
      );
    }

    // Explorer Can Publish
    siteRolePermissions.push(
        {
          role: SiteRoles.ExplorerCanPublish,
          viewInteract: true,
          subscriptionsAndAlerts: true,
          webEdit: true,
          publishViews: true
        }
    );

    // Explorer
    siteRolePermissions.push(
        {
          role: SiteRoles.Explorer,
          viewInteract: true,
          subscriptionsAndAlerts: true,
          webEdit: true
        }
    );

    // Viewer
    siteRolePermissions.push(
        {
          role: SiteRoles.Viewer,
          viewInteract: true,
          subscriptionsAndAlerts: true
        }
    );

    // Unlicensed
    siteRolePermissions.push(
        {
          role: SiteRoles.Unlicensed
        }
    );

    return siteRolePermissions;
  }
}
